// Role labels are defined in the backend and must match the values here.
export const AssistantPromptRole = "Assistant";
export const UserPromptRole = "User";
